import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import CompareItem from './CompareItem';

function CompareView({
  selectedIDs,
  toggleWorkspaceDetailView,
  dispatch,
  retrieveUMOs,
}) {
  return (
    <div className="compare-umos-view">
      <button
        onClick={() => toggleWorkspaceDetailView(false)}
        className="compare-umos-view__close-icon"
        aria-label="Close"
      />
      <div className="compare-umos__columns col-sm-12">
        {selectedIDs.map(umoID =>
          <CompareItem
            key={umoID}
            umoID={umoID}
            dispatch={dispatch}
            retrieveUMOs={retrieveUMOs}
            toggleWorkspaceDetailView={toggleWorkspaceDetailView}
            displayTwo={selectedIDs.size === 2}
          />)}
      </div>
    </div>);
}

CompareView.propTypes = {
  selectedIDs: PropTypes.instanceOf(List),
  toggleWorkspaceDetailView: PropTypes.func,
  dispatch: PropTypes.func,
  retrieveUMOs: PropTypes.func,
};

export default CompareView;



// WEBPACK FOOTER //
// ./src/js/components/CompareView/index.jsx